export const map = {
  mode: "ko",
  map: {
    adressTitle: "오시는 길",
    adress: "서울시 강남대로364 미왕빌딩 1709",
    studioTitle: "셀디 스튜디오",
    studioAdress: "서울시 강남대로116길 B1 셀디스튜디오",
  },
};
